<template>
  <div class="table_two_warp">
    <ul class="table_warp">
      <li class="table_head">
        <div v-for="(item, index) in formatData[0]" :key="index">
          {{ item[0] }}
        </div>
      </li>
      <ul class="table_body">
        <li v-for="(item, index) in formatData" :key="index">
          <div>
            <div
              v-for="(itm, idx) in item"
              :key="idx"
              :style="'color:' + (itm[1] ? colors[itm[1].level] : '')"
              @click="itmClick(itm, index)"
            >
              {{ itm[1] ? itm[1].tips : "" }}
            </div>
          </div>
          <pre
            class="table_detail"
            v-if="detailContent && rowNum === index"
            v-html="detailContent"
          ></pre>
        </li>
      </ul>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      colors: {
        0: "green",
        1: "rgb(0, 255, 255)",
        2: " rgb(255, 196, 0)",
        3: "rgb(255, 102, 0)",
        4: "red",
        5: "rgba(255, 0, 0, 0.562)",
      },
      rowNum: 0,
      detailContent: "",
    };
  },
  computed: {
    formatData() {
      let arr = [];
      this.tableData.forEach((item, index) => {
        let instance = Object.entries(item) || [];
        arr.push(instance);
      });
      return arr;
    },
  },
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    itmClick(val, index) {
      this.detailContent = JSON.stringify(val[1].detail, null, 2);
      this.rowNum = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.table_two_warp {
  background: #f1fbec;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  // max-height: 250px;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  &::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
  &::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
  & > div {
    display: flex;
    & > div {
      min-width: 100px;
      max-width: 100px;
      text-align: center;
      padding: 0 6px;
      line-height: 60px;
    }
  }
  .table_warp {
    display: flex;
    flex-direction: column;
    padding: 0;
    .table_detail {
      white-space: pre-wrap;
      padding: 16px 35px;
      border-top: 1px solid #efefef;
      margin: 0;
    }
    .table_body {
      list-style: none;
      overflow: auto;
      width: fit-content;
      max-height: 250px;
      scrollbar-width: thin;
      scrollbar-color: skyblue #eee;
      padding: 0;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
      }
      li {
        & > div {
          display: flex;
          & > div {
            min-width: 100px;
            max-width: 100px;
            text-align: center;
            padding: 0 6px;
            line-height: 60px;
            cursor: pointer;
          }
        }
      }
    }
    .table_head {
      font-weight: bold;
      display: flex;
      width: fit-content;
      border-bottom: 1px solid #efefef;
      & > div {
        min-width: 100px;
        max-width: 100px;
        text-align: center;
        padding: 0 6px;
        line-height: 30px;
      }
    }
  }
}
</style>